/**
 * Registers the slice's translations into the shared "formationGroups"
 * namespace. Side-effect import from index.tsx, like every other slice.
 */
import i18n from "@/lib/i18n/i18n";

import { formationGroupsEn } from "./locales/en";
import { formationGroupsFr } from "./locales/fr";

i18n.addResourceBundle(
  "fr",
  "translation",
  { formationGroups: formationGroupsFr },
  true,
  true,
);
i18n.addResourceBundle(
  "en",
  "translation",
  { formationGroups: formationGroupsEn },
  true,
  true,
);
